;(function () {
  'use strict';

  RetailTrackingController.$inject = [
    '$rootScope',
    '$state',
    'Asset',
    'SensorService',
    'socketIOService',
    'AssetService',
    'LoopBackAuth',
    'AppUtils'
  ];

  const angular = window.angular;
  angular
    .module('app')
    .component('retailCountTracking', {
      template:'<section><view-sidebar><view-sidebar-title><span translate>entities.asset.assetHierarchy</span><div class="btn-group btn-group-sm pull-right"><a class="btn btn-primary btn-sm" title="Clear Selection" ng-class="{disabled: !ctrl.assetId}" ui-sref=".({assetId: null})"><i class="fas fa-ban"></i></a></div></view-sidebar-title><view-sidebar-content><js-tree data="ctrl.assetsTree" selected="ctrl.assetId" on-select="ctrl.onSelectAsset(selected)"></js-tree><div class="absolute" ng-if="ctrl.loading"></div></view-sidebar-content></view-sidebar><div><view-sidebar-toggle></view-sidebar-toggle><div ng-hide="ctrl.assetSelected || ctrl.loading"><h1 class="text-center" style="margin-top: 50px">Seleccione un equipo</h1></div><div ng-class="{transparent: !ctrl.assetSelected || ctrl.loading}"><div class="container"><div ng-if="ctrl.config.status || ctrl.config.settings" class="panel panel-default no-margin"><div class="panel-heading"><ul class="nav nav-tabs" role="tablist"><li role="presentation" ng-class="{active: ctrl.activeTab===0}"><a ui-sref=".({tab: \'real-time\'})" aria-controls="Real Time" role="tab">Tiempo Real</a></li><li role="presentation" ng-class="{active: ctrl.activeTab===1}"><a ui-sref=".({tab: \'analytics\'})" aria-controls="Analytics" role="tab">Análisis</a></li><li role="presentation" ng-class="{active: ctrl.activeTab===2}"><a ui-sref=".({tab: \'info\'})" aria-controls="Info" role="tab">Información</a></li></ul></div><div class="tab-content"><div role="tabpanel" class="tab-pane active" ng-if="ctrl.activeTab===0"><retail-trace-display ng-if="ctrl.traces" traces="ctrl.traces" background-src="ctrl.assetSelected.background"></retail-trace-display></div><div role="tabpanel" class="tab-pane active" ng-if="ctrl.activeTab===1"><div class="well well-light well-sm"><div class="well-title"><i class="fas fa-chart-bar fa-fw"></i> Persisted count data <strong>{{ctrl.assetSelected.name}}</strong></div><form class="form-inline"><div class="form-group"><div style="width: 250px"><ui-select ng-model="ctrl.selectedTag" theme="select2"><ui-select-match placeholder="Sensors">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="tag in ctrl.tags | filter: {name: $select.search}">{{tag.name}}</ui-select-choices></ui-select></div></div></form><form class="form-inline marginT10"><div class="form-group"><div class="input-group"><span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="ctrl.from.open = !ctrl.from.open"><i class="fas fa-clock fa-fw"></i> From</button></span> <input type="text" class="form-control" readonly datetime-picker="dd-MM-yyyy HH:mm" is-open="ctrl.from.open" datepicker-options="ctrl.from.options" timepicker-options="ctrl.from.options" when-closed="ctrl.from.onClose(args)" ng-model="ctrl.from.value"></div></div><div class="form-group marginLR20"><div class="input-group"><span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="ctrl.to.open = !ctrl.to.open"><i class="fas fa-clock fa-fw"></i> To</button></span> <input type="text" class="form-control" readonly datetime-picker="dd-MM-yyyy HH:mm" is-open="ctrl.to.open" datepicker-options="ctrl.to.options" timepicker-options="ctrl.to.options" when-closed="ctrl.to.onClose(args)" ng-model="ctrl.to.value"></div></div></form><div class="marginT10"><retail-count-chart ng-if="ctrl.selectedTag" sensor="ctrl.selectedTag" asset="ctrl.assetSelected" from="ctrl.fromDate" to="ctrl.toDate"></retail-count-chart></div></div></div><div role="tabpanel" class="tab-pane active" ng-if="ctrl.activeTab===2"><div class="row"><div class="col-xs-12 col-ms-12 col-sm-6"><div class="well well-sm well-light"><div class="well-title"><i class="fas fa-info fa-fw"></i> Status</div><div><dl class="dl-horizontal"><dt>Ultima configuración</dt><dd>{{ctrl.config.status.lastModified | date}}</dd><dt>Activo desde</dt><dd>{{ctrl.config.status.activeSince | date}}</dd><dt>Temperatura</dt><dd>{{ctrl.config.status.temperature | number: 2}}</dd><dt>Iluminación</dt><dd>{{ctrl.config.status.illumination}}</dd><dt>Tilt</dt><dd>{{ctrl.config.status.tilt.pitch | number: 2}}° / {{ctrl.config.status.tilt.yaw |number: 2}}°</dd></dl></div></div></div><div class="col-xs-12 col-ms-12 col-sm-6"><div class="well well-sm well-light"><div class="well-title"><i class="fas fa-cog fa-fw"></i> Configuración</div><dl class="dl-horizontal"><dt>Modo</dt><dd>{{ctrl.config.settings.mode}}</dd><dt>Zona horaria</dt><dd>{{ctrl.config.settings.timezone}}</dd><dt>Altura de montaje</dt><dd>{{ctrl.config.settings.sensorheight}}</dd><dt>Rotar</dt><dd>{{ctrl.config.settings.rotate180}}</dd><dt>Frecuencia</dt><dd>{{ctrl.config.settings.powerfrequency}}</dd></dl></div></div></div><retail-trace-display ng-if="ctrl.traces" traces="ctrl.traces" floor-masking="ctrl.config.settings.floormasking" background-src="ctrl.assetSelected.background" mode="\'config\'"></retail-trace-display></div></div></div><div class="well well-light"><h2 ng-if="!ctrl.config.status && !ctrl.config.settings" class="text-center" style="margin: 50px 0">Configuración no disponible</h2></div></div></div><div class="loader-container small" ng-show="ctrl.loading"><div class="loader"><div class="loader-bg"></div><div class="loader-logo"></div></div></div></div></section>',
      controller: RetailTrackingController,
      controllerAs: 'ctrl',
      bindings: {
        $transition$: '<',
        assets: '<',
        user: '<'
      }
    });

  function RetailTrackingController ($rootScope, $state, Asset, SensorService, socketIOService, AssetService, LoopBackAuth, utils) {
    let vm = this;

    let tabOrder = ['real-time', 'analytics', 'info'];

    vm.$onInit = function () {
      vm.lastValues = {};
      vm.assetsTree = vm.assets.tree;
      vm.assets = vm.assets.assets;

      vm.onSelectAsset = onSelectAsset;

      checkAssetParam(vm.$transition$.params().assetId);

      vm.tab = getTabParam(vm.$transition$.params().tab);
      vm.activeTab = tabOrder.indexOf(vm.tab);

      vm.uiOnParamsChanged = function (params) {
        if (params.assetId !== undefined) {
          checkAssetParam(params.assetId);
        }

        if (params.tab) {
          vm.tab = getTabParam(params.tab);
          vm.activeTab = tabOrder.indexOf(vm.tab);
        }
      };

      vm.granularities = [
        { value: 1, label: '1min' },
        { value: 5, label: '5min' },
        { value: 15, label: '15min' },
        { value: 30, label: '30min' },
        { value: 60, label: '1hr' },
        { value: 360, label: '6hr' },
        { value: 720, label: '12hr' },
        { value: 1440, label: '1day' }
      ];

      vm.fromDate = new Date();
      vm.fromDate.setDate(vm.fromDate.getDate() - 1);
      vm.toDate = new Date();

      vm.from = {
        value: vm.fromDate,
        open: false,
        options: {
          showWeeks: false,
          showMeridian: false
        },
        onClose: function (args) {
          vm.fromDate = args.closeDate;
        }
      };

      vm.to = {
        value: vm.toDate,
        open: false,
        options: {
          showWeeks: false,
          showMeridian: false
        },
        onClose: function (args) {
          vm.toDate = args.closeDate;
        }
      };
    };

    function onNewData (event, data) {
      vm.lastValues[data.tagId] = data.content;
    }

    function onSelectAsset (selected) {
      vm.traces = null;
      if (!selected) {
        vm.assetSelected = null;
        return;
      }

      vm.loading = true;
      vm.tags = null;
      $state.go('.', { assetId: selected, tab: getTabParam(vm.tab) });

      if (vm.assetSelected) {
        socketIOService.unsubscribe(Asset, { id: vm.assetSelected.id, customerId: vm.assetSelected.customerId });
      }

      AssetService
        .findById(selected, { include: ['sensors', 'container'] })
        .then(function (asset) {
          vm.loading = false;
          if (!asset) {
            return;
          }

          //asset._configuration = config
          if (asset.container && asset.container._background) {
            let file = asset.container._background;
            asset.image = utils.getEntityFileUrl('Asset', asset.id, 'background', file, LoopBackAuth.accessTokenId);
          }

          socketIOService.subscribe(Asset, { id: selected });
          //asset.currentState = asset.currentState || 0
          vm.assetSelected = asset;
          vm.config = asset._config;

          if (vm.config && vm.config.settings && vm.config.settings.counting) {
            let traces = [];
            vm.config.settings.counting.forEach(current => {
              traces.push({
                path: current,
                sensor: asset.sensors.find(sensor => sensor.name === current.name)
              });
            });

            vm.traces = traces;
          }

          vm.loading = false;
          vm.tags = asset.sensors;
          vm.selectedTag = vm.tags[0];
        })
        .catch(function (err) {
          console.log(err);
          vm.loading = false;
        });
    }

    function checkAssetParam (assetParam) {
      if (assetParam) {
        if (vm.assets[assetParam]) {
          vm.assetId = assetParam;
        } else {
          $state.go('.', { assetId: null, tab: null });
        }
      } else {
        vm.assetId = null;
      }
    }

    function getTabParam (tab) {
      return tabOrder.indexOf(tab) !== -1 ? tab : 'real-time';
    }
  }
})();
